// Google Identity (button + One Tap) on every DE guest-login portal whose
// origin is registered in the GCP OAuth client. Match
// currentPortal.portal.portal (http://www.…, except portal.travanto.de),
// not window.location. Harz / Sauerland / EN stay off via show_guest_login.
// Masuren is not listed: TR-41219 keeps accounts.google.com off that portal.

const GOOGLE_LOGIN_PORTALS = new Set([
  'http://portal.travanto.de',
  'http://www.allgaeu-travel.com',
  'http://www.amrum-travel.de',
  'http://www.bauernhof-lodge.de',
  'http://www.boltenhagen-travel.de',
  'http://www.buesum-travel.com',
  'http://www.chiemsee-travel.de',
  'http://www.cuxhaven-lodge.de',
  'http://www.darss-travel.de',
  'http://www.fehmarn-travel.de',
  'http://www.foehr-travel.de',
  'http://www.hamburg-lodge.de',
  'http://www.hunde-lodge.de',
  'http://www.kiel-travel.de',
  'http://www.luebeck-travel.de',
  'http://www.lueneburg-travel.de',
  'http://www.mueritz-travel.de',
  'http://www.polen-travel.com',
  'http://www.praha-lodge.com',
  'http://www.ruegen-travel.de',
  'http://www.scharbeutz-travel.de',
  'http://www.schwarzwald-travel.de',
  'http://www.see-ferienwohnung.de',
  'http://www.sizilien-travel.com',
  'http://www.stpeterording-travel.de',
  'http://www.sylt-travel.de',
  'http://www.timmendorferstrand-travel.de',
  'http://www.travanto.de',
  'http://www.usedom-travel.net',
  'http://www.wintersport-lodge.de'
])

export default function useGoogleLoginEnabled (): boolean {
  if (!useGuestLoginEnabled()) {
    return false
  }

  const { currentPortal } = usePortals()
  const portal = currentPortal.value?.portal?.portal ?? ''
  return GOOGLE_LOGIN_PORTALS.has(portal)
}
